<template>
  <div id="app">
    <div id="meifuApp">
      <router-view />
    </div>
  </div>
</template>

<script>
import "@/assets/css/reset.css";
import "@/assets/css/index.less";
import api from "@/api";
import ls from "store2";
import { loginifo, notmove } from "@/api/pubrequst.js";
// import { saveAs } from "file-saver/FileSaver";
import { edition } from "@/common/config.js";
import Base64 from "@/util/encryptlong";
import { getCurToken, setUserInfo } from "./util";

export default {
  data() {
    return {
      userInfo: {},
      lastTime: new Date().getTime(),
      currentTime: new Date().getTime(),
      timeOut: 30 * 60 * 1000, //过期时间 30 * 60 * 1000
      timer: null, //定时器的名字
      overdueindesx: 0, //过期的次数
    };
  },
  components: {},
  mounted() {
    this.OSnow();
    this.init();
  },
  methods: {
    createImpl(canvas) {
      if (leftHeight > 0) {
        index++;

        var checkCount = 0;
        if (leftHeight > a4HeightRef) {
          var i = position + a4HeightRef;
          for (i = position + a4HeightRef; i >= position; i--) {
            var isWrite = true;
            for (var j = 0; j < canvas.width; j++) {
              var c = canvas.getContext("2d").getImageData(j, i, 1, 1).data;

              if (c[0] != 0xff || c[1] != 0xff || c[2] != 0xff) {
                isWrite = false;
                break;
              }
            }
            if (isWrite) {
              checkCount++;
              if (checkCount >= 10) {
                break;
              }
            } else {
              checkCount = 0;
            }
          }
          height =
            Math.round(i - position) || Math.min(leftHeight, a4HeightRef);
          if (height <= 0) {
            height = a4HeightRef;
          }
        } else {
          height = leftHeight;
        }

        canvas1.width = canvas.width;
        canvas1.height = height;

        var ctx = canvas1.getContext("2d");
        ctx.drawImage(
          canvas,
          0,
          position,
          canvas.width,
          height,
          0,
          0,
          canvas.width,
          height
        );

        var pageHeight = Math.round((a4Width / canvas.width) * height);
        // pdf.setPageSize(null, pageHeight)
        if (position != 0) {
          pdf.addPage();
        }
        pdf.addImage(
          canvas1.toDataURL("image/jpeg", 1.0),
          "JPEG",
          0,
          0,
          a4Width,
          (a4Width / canvas1.width) * height
        );
        leftHeight -= height;
        position += height;
        $(".pdfProgress").text(index + 1);
        $(".pdfTotal").text(index + Math.ceil(leftHeight / a4HeightRef));
        if (leftHeight > 0) {
          setTimeout(createImpl, 500, canvas);
        } else {
          pdf.save(pdfName + ".pdf");
          $(".pdfTip").remove();
        }
      }
    },

    init() {
      //设定日期

      let that = this;
      that.$Message.config({
        duration: 4,
        //duration:1000
      });
      window.document.onmousedown = function () {
        if (!that.overdueindesx == 0) {
          loginifo(2).then(() => {
            that.overdueindesx = 0;
          });
        }
        localStorage.setItem("lastTime", new Date().getTime());
        that.lastTime = new Date().getTime();
      };
      window.onunload = () => {
        //点击关闭按钮
        notmove(2);
      };
      this.timer = window.setInterval(this.checkTimeout, 1000 * 60 * 3);
    },
    checkTimeout() {
      this.currentTime = new Date().getTime(); //更新当前时间

      this.lastTime = localStorage.getItem("lastTime");

      if (this.currentTime - this.lastTime > this.timeOut) {
        //判断是否超时
        notmove(3).then(() => {
          localStorage.setItem("lastTime", new Date().getTime());
          this.lastTime = new Date().getTime();
          this.overdueindesx = 1;
        });
      }
    },

    judgeShowPage() {
      const curPath = window.location.pathname;
      // 存在用户id或者当前为[登录页]
      const flag =
        this.userInfo.authority ||
        ["/admin/login", "/customer/login", "/loading", "/azure"].indexOf(
          curPath
        ) > -1;
      if (flag) document.getElementById("meifuApp").style.display = "block";
      // else  document.getElementById("meifuApp").style.display = "none"
    },
    OSnow() {
      var agent = navigator.userAgent.toLowerCase();
      var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
      if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0) {
        //alert("这是windows32位系统");
        document.getElementsByTagName("body")[0].className = "wid";
      }
      if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
        // alert("这是windows64位系统");

        document.getElementsByTagName("body")[0].className = "wid";
      }
      if (isMac) {
        //  alert("这是mac系统");
        document.getElementsByTagName("body")[0].className = "pg";
      }
    },
  },

  watch: {
    $route() {
      this.$store.state.spinShow = true;
      let userInfo = ls.page("userInfo");

      if (userInfo) {
        this.userInfo = JSON.parse(Base64.decode(ls.page("userInfo"))) || {};
      }

      this.judgeShowPage();
    },
  },
};
</script>
<style>
.pg {
  font-family: "PingFangSC-Regular", "sans-serif" !important;
}

.wid {
  font-family: "Microsoft YaHei", "微软雅黑 " !important;
}
</style>
<style lang="less">
@import "./assets/css/public.css";
.errstatus {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #f5222d;
}

.succstatus {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #c6c6c6;
}
.ivu-table-tbody {
  td {
    padding: 10px 0;
  }
}
// .ivu-icon {
//   display: none !important;
// }
.ivu-page-item-active{
   &:hover {
    border-color: #0c479d !important;
  }
}
// .ivu-page-item {
 
//   &:hover {
//     border: none !important;
//   }
// }
</style>
